module.exports = __webpack_public_path__ + "img/suplidores3.97c593ca.png";